import {
  Component,
  OnInit,
  OnChanges,
  SimpleChange,
  Input,
  EventEmitter,
  Output,
  ViewChild,
  ElementRef
} from "@angular/core";
import { NeededPartItem } from "../neededpartitem";
import { LaborGuideItem } from "../labor-guide-item";
import { LaborService } from "../labor.service";
import { JsonpClientBackend } from "@angular/common/http";
import { LabortreeComponent } from "../labortree/labortree.component";
import { isDefaultChangeDetectionStrategy } from "@angular/core/src/change_detection/constants";
import { EPartType } from "../customItem";

@Component({
  selector: "app-labordetail",
  templateUrl: "./labordetail.component.html",
  styleUrls: ["./labordetail.component.css"]
})
export class LabordetailComponent implements OnInit, OnChanges {
  @Input() laborId: number;
  @Input() isAdmin: boolean;
  @Input() parentName: string;
  @Input() laborType: string;
  @Input() action: string;
  @Input() allLabors: [];
  @Output() addNew = new EventEmitter<LaborGuideItem>();
  @Output() update = new EventEmitter<LaborGuideItem>();
  @Output() verifiedLabor = new EventEmitter<number>();
  @ViewChild("title") title: ElementRef;
  @ViewChild("laborTree") laborTree: LabortreeComponent;
  copyNeededPart: NeededPartItem[] = [];
  copyLgItem = new LaborGuideItem(0, 0, "", "", 0, "", "", "", false, 0, 1, "");
  copyParentId = 0;

  neededParts: NeededPartItem[] = [];
  lgItem = new LaborGuideItem(0, 0, "", "", 0, "", "", "", false, 0, 1, "");
  labors = [];
  selectedLabor: any;
  isDisplayedNeededPart = false;
  selectedParentId = 0;
  parentLabor: any;
  anotherOption: false;
  isLoading: boolean = false;
  currentVinNumber = "";
  quantities: string[] = ["1", "2", "3", "4", "5", "Specification"];
  keys = [];
  partTypes = EPartType;
  constructor(private laborService: LaborService) {
    this.keys = Object.keys(this.partTypes).filter(
      key => !isNaN(Number(this.partTypes[key]))
    );
  }

  ngOnInit() { }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    this.isDisplayedNeededPart = false;
    if (changes.hasOwnProperty("laborId") && this.action == "edit") {
      let currentLaborId = changes["laborId"].currentValue;
      this.loadData(currentLaborId);
    } else if (this.action == "addTerminal") {
      this.title.nativeElement.focus();
      this.selectedParentId = this.laborId;
      //reset data
      this.resetData();
      this.lgItem.ParentId = this.laborId;
      this.isDisplayedNeededPart = true;
    } else if (this.action == "addCategory") {
      this.title.nativeElement.focus();
      this.selectedParentId = this.laborId;
      this.resetData();
      if (this.laborType != "main") {
        this.lgItem.ParentId = this.laborId;
      }
    } else {
      //reset data
      this.resetData();
    }

    if (changes.hasOwnProperty("parentName")) {
      this.parentName = changes["parentName"].currentValue;
    }
  }

  isDisplayLaborTree(): boolean {
    if (this.laborType != "main") {
      return true;
    }
    return false;
  }

  refreshCat(): void {
    this.laborTree.refreshCat();
  }

  verifyLabor(isVerified: any) {
    this.lgItem.IsVerified = isVerified;
    this.laborService
      .updateLabor(this.lgItem, this.neededParts)
      .subscribe(result => {
        if (isVerified == 1) {
          this.verifiedLabor.emit(this.lgItem.LaborGuideId);
        }
      });
  }

  resetData(): void {
    this.neededParts = [];
    this.lgItem = new LaborGuideItem(
      0,
      0,
      "",
      "",
      0,
      "",
      "",
      "",
      false,
      0,
      1,
      ""
    );
    this.addNewItem(0);
  }

  loadData(laborId: any) {
    this.isLoading = true;
    this.laborService.getLaborById(laborId).subscribe(data => {
      this.lgItem = data.Labor;
      this.copyLgItem = Object.assign({}, data.Labor);

      for (var i = 0; i < data.NeededParts.length; i++) {
        if (data.NeededParts[i].Quantity == 0) {
          data.NeededParts[i].QuantityValue = "Specification";
        } else {
          data.NeededParts[i].QuantityValue = data.NeededParts[
            i
          ].Quantity.toString();
        }
        let ptName = this.getPTName(data.NeededParts[i].PartType);

        data.NeededParts[i].PartTypeName = ptName;
      }
      this.copyParentId = data.Labor.ParentId;
      this.neededParts = data.NeededParts;

      this.copyNeededPart = JSON.parse(JSON.stringify(data.NeededParts)); //data.NeededParts.slice();
      if (this.neededParts.length == 0) {
        this.addNewItem();
      }
      this.isLoading = false;
    });
  }

  getPTName(id): string {
    return Object.keys(this.partTypes).find(key => this.partTypes[key] === id);
  }

  setParentCat($event): void {
    let cat = $event;
    this.parentName = cat.Name;
    this.selectedParentId = cat.LaborGuideId;
    this.lgItem.ParentId = cat.LaborGuideId;
    this.lgItem.ParentName = cat.Name;
  }

  filterNeededParts() {
    return this.neededParts.filter(n => !n.IsDelete);
  }

  save() {
    this.isLoading = true;
    this.neededParts = this.neededParts.filter(ele => {
      return ele.Name != "";
    });

    this.neededParts.forEach(n => {
      if (n.QuantityValue == "Specification") {
        n.Quantity = 0;
        n.SpecificationQuantity = true;
      } else {
        n.Quantity = parseFloat(n.QuantityValue);
        n.SpecificationQuantity = false;
      }
      n.PartType = this.partTypes[n.PartTypeName];
    });
    
    if (this.action == "edit") {
      this.laborService
        .updateLabor(this.lgItem, this.neededParts)
        .subscribe(result => {
          this.isLoading = false;
          this.update.emit(this.lgItem);
          this.resetData();
        });
    } else {
      switch (this.action) {
        case "addTerminal":
          this.lgItem.Type = "Terminal";
          break;
        default:
          this.lgItem.Type = "Category";
          break;
      }

      this.lgItem.ParentName = this.parentName;
      this.laborService
        .addLabor(this.lgItem, this.neededParts)
        .subscribe(newLabor => {
          this.isLoading = false;
          this.addNew.emit(newLabor);
          this.resetData();
        });
    }
  }

  detectChange(): boolean {
    let isChanged = false;
    if (this.lgItem.Title != "") {
      this.neededParts = this.neededParts.filter(ele => {
        return ele.Name != "";
      });
      this.copyNeededPart = this.copyNeededPart.filter(ele => {
        return ele.Name != "";
      });

      let isChangeLgItem =
        JSON.stringify(this.lgItem) !== JSON.stringify(this.copyLgItem);
      let isChangeNeededPart =
        JSON.stringify(this.neededParts) !==
        JSON.stringify(this.copyNeededPart);
      let isChangeCategory = this.copyParentId != this.lgItem.ParentId;

      if (isChangeCategory) {
        isChanged = true;
      }
      if (isChangeLgItem) {
        isChanged = true;
      }
      if (isChangeNeededPart) {
        isChanged = true;
      }
    }
    return isChanged;
  }

  displaySearchTerm(i: number){
    return this.neededParts[i].IsSearchTerm;
  }

  changeSearchTerm(currentRowIndex = 0) {    
    this.neededParts.forEach(element => {
      element.IsSearchTerm = false;
    });    
    this.neededParts[currentRowIndex].IsSearchTerm = true;                
  }

  addNewItem(index = 0) {
    let filteredNeededPart = this.neededParts.filter(n => !n.IsDelete);
    if (index == filteredNeededPart.length) {
      let newItem: NeededPartItem = {
        NeededPartId: 0,
        Name: "",
        Location: "",
        Quantity: 0,
        SpecificationQuantity: false,
        IsDelete: false,
        PartType: 0,
        QuantityValue: "",
        PartTypeName: "Part",
        IsSearchTerm : false
      };
      this.neededParts.push(newItem);
    }
  }

  isAvalaibleForSave() {
    if (this.lgItem.Title == "") {
      return true;
    } else if (this.isLoading) {
      return true;
    }
    return false;
  }
}
